import { axios } from '../../../lib/axios.ts';
import { SurveyItem } from '../types/index.ts'

export const getDoneSurveyAPI = async (): Promise<SurveyItem[]> => {
    const response = await axios.get('/survey/done') as { items: SurveyItem[] };
    return response;
};
